export enum AppType {
  LeisureKing = 'leisureking',
}

export const appType = computed(() => {
  return AppType.LeisureKing
})
